<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="cont" epub:type="toc" role="doc-toc">
<header>
<h1 class="FMH" id="cont"><span aria-label=" Page vii. " epub:type="pagebreak" id="pg_vii" role="doc-pagebreak"><span class="small">CONTENTS</span></span></h1>
</header>
<ol class="toc">
<li class="CCT1"><a href="#/xhtml/introduction">Introduction</a></li>
<li class="CCTAU"><i>Tisa Wenger and Sylvester A. Johnson</i></li>
<li class="CPT"><a href="#/xhtml/part1"><span class="small">PART I. FORMATIONS: SLAVERY, SETTLERS, AND SALVATION</span></a></li>
<li class="CCT"><a href="#/xhtml/chapter1">  1.  Rebellion and Religion: Slavery and Empire in Early America</a></li>
<li class="CCTAU"><i>Katharine Gerbner</i></li>
<li class="CCT"><span href="#/xhtml/chapter2" title="Link target outside of Sample">  2.  Making Religion in Michilimackinac: Settler Secularism and US Empire</span></li>
<li class="CCTAU"><i>Tisa Wenger</i></li>
<li class="CCT"><span href="#/xhtml/chapter3" title="Link target outside of Sample">  3.  A Colony Called Freedom: Religion, Empire, and Black Christian Settlers</span></li>
<li class="CCTAU"><i>Sylvester A. Johnson</i></li>
<li class="CPT"><span href="#/xhtml/part2" title="Link target outside of Sample"><span class="small">PART II. BIOPOLITICS: IMPERIAL CLASSIFICATIONS, SENTIMENTAL REFORM, AND INDIGENOUS TACTICS OF SURVIVAL</span></span></li>
<li class="CCT"><span href="#/xhtml/chapter4" title="Link target outside of Sample">  4.  Religion on the Brink: Settler-Colonial Knowledge Production in the US Census</span></li>
<li class="CCTAU"><i>Sarah Dees</i></li>
<li class="CCT"><span href="#/xhtml/chapter5" title="Link target outside of Sample">  5.  Imperial Intersections: Social Surveys, Sentimental Biopolitics, and Religion at Hull House</span></li>
<li class="CCTAU"><i>Cara Lea Burnidge</i></li>
<li class="CCT"><span href="#/xhtml/chapter6" title="Link target outside of Sample">  6.  “They Call It Ghost Dance … But It’s Feather Dance”: Indigenous Histories in the Study of Religion and US Empire</span></li>
<li class="CCTAU"><i>Jennifer Graber</i></li>
<li class="CPT"><span aria-label=" Page viii. " epub:type="pagebreak" id="pg_viii" role="doc-pagebreak"><span href="#/xhtml/part3" title="Link target outside of Sample"><span class="small">PART III. ENTANGLEMENTS: GLOBAL NETWORKS, CHRISTIAN MISSIONS, AND THE RACIAL PROJECTS OF US EMPIRE</span></span></span></li>
<li class="CCT"><span href="#/xhtml/chapter7" title="Link target outside of Sample">  7.  “The Same Blood as We in America”: Industrial Schooling and American Empire</span></li>
<li class="CCTAU"><i>Karine Walther</i></li>
<li class="CCT"><span href="#/xhtml/chapter8" title="Link target outside of Sample">  8.  Black Spiritual Protest in Global Imperial Contexts, 1893–1920</span></li>
<li class="CCTAU"><i>Heather D. Curtis</i></li>
<li class="CCT"><span href="#/xhtml/chapter9" title="Link target outside of Sample">  9.  An Evangelical Occupation: The Racial and Imperial Politics of US Protestant Missions in the Dominican Republic</span></li>
<li class="CCTAU"><i>Christina C. Davidson</i></li>
<li class="CPT"><span href="#/xhtml/part4" title="Link target outside of Sample"><span class="small">PART IV. DIALECTICS: WASTELANDING, WEAPONRY, AND CAPITALIST EXCLUSIONS</span></span></li>
<li class="CCT"><span href="#/xhtml/chapter10" title="Link target outside of Sample">10.  The Trouble of an Indian Diocese: Catholic Priests and Sexual Abuse in Colonized Places</span></li>
<li class="CCTAU"><i>Kathleen Holscher</i></li>
<li class="CCT"><span href="#/xhtml/chapter11" title="Link target outside of Sample">11.  Fire from Heaven: Napalm, the Drone, and Evangelical Territoriality in the Age of Empire</span></li>
<li class="CCTAU"><i>Jonathan Ebel</i></li>
<li class="CCT"><span href="#/xhtml/chapter12" title="Link target outside of Sample">12.  American Islam, Settler Colonialism, and Democratic Empires in the Work of Robert D. Crane</span></li>
<li class="CCTAU"><i>Zareena A. Grewal and Brennan McDaniel</i></li>
<li class="CCT"><span href="#/xhtml/chapter13" title="Link target outside of Sample">13.  Decolonization™</span></li>
<li class="CCTAU"><i>Lucia Hulsether</i></li>
<li class="tocbmf"><span href="#/xhtml/acknowledgments" title="Link target outside of Sample"><i>Acknowledgments</i></span></li>
<li class="CBMH"><span href="#/xhtml/bibliography" title="Link target outside of Sample"><i>Bibliography</i></span></li>
<li class="CBMH"><span href="#/xhtml/abouttheauthor" title="Link target outside of Sample"><i>About the Editors</i></span></li>
<li class="CBMH"><span href="#/xhtml/abouttheeditor" title="Link target outside of Sample"><i>About the Contributors</i></span></li>
<li class="CBMH"><span href="#/xhtml/index" title="Link target outside of Sample"><i>Index</i></span></li>
</ol>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?349d22e7